import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Body, Bold, Subtitle } from '@panwds/react-ui'

const LicenseLineItem = ({ label, value, color, labelColor }) => {

  const colorClassName = useCallback((color) => {
    switch (color) {
      case 'green':
        return 'tw-text-green-400'
      case 'default':
      default:
        return 'tw-text-gray-600'
    }
  }, [])

  return <Body size='md'><Bold addClassName={colorClassName(labelColor)}>{label}</Bold> <Subtitle addClassName={colorClassName(color)} size='md'> {value}</Subtitle></Body>
}

LicenseLineItem.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  color: PropTypes.oneOf([
    'green',
    'default'
  ])
}

LicenseLineItem.defaultProps = {
  color: 'default'
}

export default LicenseLineItem
